import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMoneyBill } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import downloadit from '../../../../../../utils/download';
import { useModal } from 'src/hooks/Modal';
import { formatReal } from 'src/utils/format';

interface ICreateModule {
  lineData: Record<string, any>;
}

export const CheckGlobalFinance  = () => {
  const {user} = useAuth();
  const {projectHash} = useParams<Record<string,any>>();
  const {addToast} = useToast();
  const {addModal} = useModal();

    const sacar = async (project) => {
 
 
 await api.post(`/make-marketplace-direct-transfer/${project?._id}`, { saldo: project?.saldo});
 addToast({title: `${project?.title}`})
  
 

  }

  const realizarSaques = async (data) => {

    let x = 0;
while(  x < data?.length ){

const project = data[x];
 await api.post(`/make-marketplace-direct-transfer/${project?._id}`, { saldo: project?.saldo});
 addToast({title: `${x + 1} de ${data?.length} - ${project?.title}`})
  x+=1;
}

  }
    
  const gerarRelatorioFinanceiro = async() => {

    addToast({title:'Gerando relatório', type:'info'});
    
    const dataList : Record<string,any>[] = [];
    const projects = await api.get(`/projects`, { params: { where: { new_finance : 'yes'}, limitItems:1000}});

let x = 0;

while(  x < projects?.data?.rows?.length ){

const project = projects?.data?.rows[x];
const data = await api.get(`/check-saldo-static/${project?.url}/json`);
dataList.push({_id: project?._id?.toString(), title: project?.title, project_id : project?.url, saldo: data?.data?.rows?.length > 0 ? data?.data?.rows?.[data?.data?.rows?.length -1 ]?.saldo : 0})
addToast({title: `${x + 1} de ${projects?.data?.rows?.length} - ${project?.title}`})
console.log(data?.data?.rows?.[data?.data?.rows?.length -1 ]?.saldo)
  x+=1;
}


dataList.sort((a,b) => a?.saldo > b?.saldo ? -1: a?.saldo < b?.saldo ? 1 : 0)


  addModal({title: '', theme: 'whiteModal', content: <> 
{/*}
  <button className='greenButton2' onClick={() => {


    realizarSaques(dataList.filter(a=> a?.saldo > 0))
  }}>Realizar Saques</button> */}
  <table>
    <tbody>
      {dataList?.map( item => <tr><td>{item?.saldo > 0 ? <button className='greenButtton' onClick={() => {sacar(item)}}>Sacar</button> : <></>}</td><td>{item?.project_id}</td><td>{item?.title}</td><td>{item?.saldo}</td></tr>)}


    </tbody>
  </table>
  
  </>})
    
   
  
  }

  const moduleUpdate = (): JSX.Element => (
    user?.email === 'guilherme@encontrodigital.com.br' ? <button className="searchButton" type="button" onClick={gerarRelatorioFinanceiro}>
    <FaMoneyBill/>
  </button> : <></>
  );

  return moduleUpdate();
}
